import Styled from 'styled-components';

interface WrapperLoadingProps {
  minHeight?: number;
}

const WrapperLoading = Styled.div<WrapperLoadingProps>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: ${({ minHeight }) => `${minHeight}px`};

  > div {
    position: absolute;
  }
`;

const WrapperLoadingFullPage = Styled(WrapperLoading)`
  height: 60vh;
`;

export default WrapperLoading;
export { WrapperLoading, WrapperLoadingFullPage };
